import { useState } from "react";
import { useTranslation } from 'react-i18next';

const AcardionMenuItem = ({ item, activeItem, setActiveItem, activeSubItem, setActiveSubItem, navigate }: any) => {
    const { t } = useTranslation();
    const onNavigate = (item: any) => {
        // if (activeItem === 'sports') {
        //     navigate(item.id);
        //     setActiveSubItem(item.id);

        //     return;

        // }
        setActiveSubItem(item.id); 
        navigate(activeItem)
    };

    return (
        <div className={`accordion-content ${activeItem === item.id ? 'expanded' : ''}`}>
            <div className="accordion-content-inner">
                {item.context.map((subItem: any, index: any) => (
                    <button key={index} className={`accordion-sub-item ${activeSubItem === subItem.id ? ' active' : ''}`} onClick={() => { onNavigate(subItem); }}>
                        <span className={`transition-all duration-300 ${activeSubItem === subItem.id ? '[&_svg]:opacity-100 [&_svg]:brightness-125' : '[&_svg]:opacity-40'} [&_svg]:w-[20px] [&_svg]:h-[20px]`}>{subItem.icon}</span>
                        {t(subItem.labelKey)}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default AcardionMenuItem